var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorizingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6dtb134oxa",
    x1: "5.935%",
    x2: "43.498%",
    y1: "46.309%",
    y2: "91.099%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#17A141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C6C4C4",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#6dtb134oxa)",
    fillRule: "nonzero",
    transform: "translate(-1224 -634)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.993 34.444c-.786 0-1.424-.678-1.424-1.516 0-.837.638-1.516 1.424-1.516 5.488 0 9.937-4.736 9.937-10.579 0-5.842-4.45-10.578-9.937-10.578-5.305 0-9.668 4.437-9.924 10.055-.038.837-.706 1.482-1.492 1.441-.785-.04-1.391-.751-1.353-1.588.33-7.231 5.943-12.94 12.77-12.94 7.06 0 12.784 6.093 12.784 13.61 0 7.518-5.724 13.611-12.785 13.611zm-.855-.317c-.792-.03-1.41-.675-1.378-1.439.032-.764.7-1.358 1.492-1.328.135.005.27.008.405.008.793 0 1.436.62 1.436 1.384 0 .765-.643 1.385-1.436 1.385-.173 0-.347-.004-.52-.01z",
    transform: "translate(1216 627) rotate(25 20 20.833)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizingIcon);
export default __webpack_public_path__ + "static/media/authorizing-icon.47a14f7a.svg";
export { ForwardRef as ReactComponent };